import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import * as TbIcons from "react-icons/tb";
import * as CgIcons from "react-icons/cg";
import { makeStyles } from "@material-ui/styles";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { resetReducer } from "../../../store/reducers/digitalmarketing/customer";
import PermissionCheck from "../../../Component/PermissionCheck";
import { initialMedicine } from ".";

const useStyles = makeStyles({
  menu: {
    "& .MuiPaper-elevation": {
      borderRadius: "10px",
    },
  },
});
function DashTabs(props) {
  const { onFilter, handleOpen, setshow, show, setMedicine } = props;
  const classes = useStyles();
  const [activeId, setActiveId] = useState<any>(1);
  const DashboardStatus = useSelector((state: any) => state.dashboard.status);
  const dispatch = useDispatch<any>();
  const [upd, setUpd] = useState(false);

  const values = [
    { id: 1, text: "Patient detail" },
    { id: 2, text: "e-Prescription" },
    { id: 3, text: "Test reports" },
  ];

  return (
    <div className="Dash-table mt-4" style={{ height: "50px" }}>
      {/* <ul>
        {values.map((val, i) => (
          <li
            onClick={() => setActiveId(val.id)}
            key={i}
            className={activeId === val.id ? "acti" : ""}
          >
            {val.text}
          </li>
        ))}
      </ul> */}
      <div style={{ float: "right" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <Button
            variant="contained"
            id="btn"
            style={{ padding: show ? "10px" : "10px" }}
            onClick={() => {
              setshow(!show);
              setMedicine(initialMedicine);
            }}
          >
            {show ? "x  Close" : "+ Add Medicine"}{" "}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default React.memo(DashTabs);
